import type { ReactNode } from 'react'

import { customMedia } from '@space-core/styles'

import styled from 'styled-components'

export interface GridModalProps {
  children: ReactNode
  className?: string
}

const Grid = styled.div`
  display: grid;
  align-items: start;
  grid-template-columns: repeat(auto-fit, minmax(45rem, 1fr));

  ${customMedia.lessThan('lg')`
    grid-template-columns: auto;
  `}
`

const GridBase = ({ children, className }: GridModalProps) => {
  return (
    <Grid className={className} data-test='default-base-grid'>
      {children}
    </Grid>
  )
}

export default GridBase
